export default "dc73ff35f84950f2.svg"